import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import logo from '../img/logo.png';
import { Helmet } from 'react-helmet';
import axios from 'axios';
import { FaAddressBook, FaFilePdf, FaGift, FaHeart, FaImage, FaMoneyBillWave, FaMusic, FaPalette, FaSpinner, FaWhatsapp } from 'react-icons/fa';
import Recommended from '../components/Recommended';
import NavBar from '../components/NavBar';
import FeaturesModal from '../components/FeaturesModal';

const Manage = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [event, setEvent] = useState('');
  const [walimatulurus, setWalimatulurus] = useState('');
  const [status, setStatus] = useState('');
  const [groomName, setGroomName] = useState('');
  const [brideName, setBrideName] = useState('');
  const [message, setMessage] = useState('');
  const [weddingDate, setWeddingDate] = useState('');
  const [parentName, setParentName] = useState('');
  const [location, setLocation] = useState('');
  const [createdAt, setCreatedAt] = useState('');
  const [timeLeft, setTimeLeft] = useState({ hours: 0, minutes: 0, seconds: 0 });
  const [expired, setExpired] = useState(false);
  const [showNotification, setShowNotification] = useState(false);

  const [temaStatus, setTemaStatus] = useState(0);
  const [musicStatus, setMusicStatus] = useState(0);
  const [rsvpStatus, setRsvpStatus] = useState(0);
  const [moneyGift, setMoneyGift] = useState(0);
  const [galleries, setGalleries] = useState(0);
  const [pdfStatus, setPdfStatus] = useState(0);
  const [pakej, setPakej] = useState(0);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const features = async (pakej) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/features/${pakej}`);
      const data = response.data;

      setTemaStatus(data.designs);
      setMusicStatus(data.music);
      setRsvpStatus(data.rsvp);
      setMoneyGift(data.money_gift);
      setGalleries(data.galleries);
      setPdfStatus(data.pdf);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/kad/${id}`);
        const data = response.data;

        setWalimatulurus(data.walimatulurus);
        setStatus(data.status);
        setGroomName(data.groom_name);
        setBrideName(data.bride_name);
        setWeddingDate(data.wedding_date);
        setParentName(data.parent_name);
        setMessage(data.message);
        setLocation(data.location);
        setCreatedAt(data.created_at);
        setPakej(data.pakej);
        features(data.pakej);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, [id]); 

  useEffect(() => {
    const getEvent = async () => {
      axios.get(`${process.env.REACT_APP_API_BASE_URL}/clients/${id}`)
        .then(response => {
          const event = response.data.event;
          setEvent(event);
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    };

    getEvent();

  }, [id]);

  useEffect(() => {
    // Function to calculate the time difference
    const calculateTimeLeft = () => {
      const expirationTime = new Date(createdAt).getTime() + 1 * 60 * 60 * 1000;
      const currentTime = new Date().getTime();
      const difference = expirationTime - currentTime;

      if (difference > 0) {
        const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((difference / (1000 * 60)) % 60);
        const seconds = Math.floor((difference / 1000) % 60);
        setTimeLeft({ hours, minutes, seconds });
      } else {
        // If the expiration time has passed
        setTimeLeft({ hours: 0, minutes: 0, seconds: 0 });
        setExpired(true);
      }
    };

    // Update the countdown every second
    const interval = setInterval(calculateTimeLeft, 1000);

    // Cleanup the interval on component unmount
    return () => clearInterval(interval);
  }, [createdAt]);

  const weddingDateSet = new Date(weddingDate);
  const weddingDay = getDayFromDate(weddingDateSet);

  // Check if wedding date has passed more than 1 day
  const isEditDisabled = () => {
    const today = new Date();
    const oneDayAfterWedding = new Date(weddingDateSet);
    oneDayAfterWedding.setDate(oneDayAfterWedding.getDate() + 1);
    return today > oneDayAfterWedding;
  };

  const formattedDate = weddingDateSet.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  // Function to calculate the day from a given date
  function getDayFromDate(date) {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const dayIndex = date.getDay();
    localStorage.setItem('Day', days[dayIndex]);
    return days[dayIndex];
  }
  
  const url = `${process.env.REACT_APP_KAD_BASE_URL}/${id}`;
  const edit = `/edit/${id}`;
  const rsvp = `/rsvp/${id}`;
  const music = `/music/${id}`;
  const salamkaut = `/salamkaut/${id}`;
  const hadiah = `/hadiah/${id}`;
  const aktifkan = `/select-plan/${id}`;
  const tema = `/designs/${id}`;
  const gallery = `/gallery/${id}`;
  const pdf = `/pdf/${id}`;

  const shareText = `
❤️ ${walimatulurus} ❤️

${groomName} & ${brideName}
      
${url}
          
🗓️ ${weddingDay}, ${formattedDate}
📍 ${location}

Don't forget to RSVP

#${event}
  `;

  const handleCopy = () => {
    const textarea = document.getElementById('invitationText');
    textarea.select();
    document.execCommand('copy');
    alert('Text copied to clipboard!');
  };

  const handleHashtag = () => {
    axios.put(`${process.env.REACT_APP_API_BASE_URL}/update-hashtag/${id}`, { event: event })
      .then(response => {
          console.log(response.data.message); // Log success message
          alert('Hashtag updated');
          window.location.reload();
      })
      .catch(error => {
          console.error('Error updating hashtag:', error);
      });
  };

  const handleDisabledEditClick = () => {
    setShowNotification(true);
    setTimeout(() => setShowNotification(false), 3000); // Hide after 3 seconds
  };

  const [phoneNumber, setPhoneNumber] = useState(false);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/settings`)
      .then(response => setPhoneNumber(response.data.whatsapp_no))
      .catch(error => console.error('Error fetching settings:', error));
  }, []);

  const handleClick = (e) => {
    e.preventDefault(); // Prevent navigation
    setIsModalOpen(true); // Open modal
  };

  return (
    <div className="relative">
      <Helmet>
        <title>Dashboard | {process.env.REACT_APP_SITE_NAME}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      {loading ? ( 
          <div className="fixed inset-0 flex flex-col items-center justify-center space-y-5">
            <FaSpinner className="text-4xl text-black animate-spin" />
            <img src={logo} alt="Logo" className="h-10 mb-4" />
          </div>
        ) : (
          <div>
            {showNotification && (
              <div className="fixed top-1/4 left-1/2 transform -translate-x-1/2 bg-red-100 border border-red-400 text-red-700 px-6 py-3 rounded-lg shadow-lg z-50 animate-fade-in">
                <p className="text-center">Cannot edit after event</p>
              </div>
            )}
            <NavBar />
            <div className="bg-gray-50 flex pt-20 justify-center min-h-screen">
              <div className=" px-8 py-8 max-w-md w-full">

                {status === 'unverified' ?(
                  <div className='flex items-center justify-between pb-2'>
                    <div>
                      {expired ? (
                        <p>Status: <span className='font-bold text-secondary-700'>Expired</span></p> // Display "Expired" when the time is up
                      ) : (
                        <>
                          <p>Status: <span className='font-bold'>Trial</span></p>
                          <p className='text-sm'>Trial ends in: {timeLeft.hours}h: {timeLeft.minutes}m: {timeLeft.seconds}s</p>
                        </>
                      )}
                    </div>
                    <div className='space-x-2'>
                      <a
                        href={url}
                        target="_blank"
                        rel="noreferrer"
                        className='btn-secondary'>
                          View
                      </a>
                      <a
                        href={aktifkan}
                        rel="noreferrer"
                        className='px-3 py-2 rounded-lg bg-primary hover:bg-secondary text-highlight'>
                          Activate
                      </a>
                    </div>
                  </div>
                ):(
                  <div className='flex items-center justify-between pb-2'>
                    <p>Status: <span className='font-bold text-green-500'>Active</span></p>
                    <a
                      href={url}
                      target="_blank"
                      rel="noreferrer"
                      className='btn-secondary'>
                        View
                    </a>
                  </div>
                )}
                
                <p className='text-sm pb-4'>Plan: <span className='font-bold text-accent uppercase'>{pakej}</span></p>


                <div className='relative px-5 py-2 rounded-lg shadow-xl mb-8 bg-white'>
                  {/* Icons in the background */}
                  <div className="absolute inset-0 flex justify-center items-center opacity-30">
                    {/* Adjust the number of icons and their size as needed */}
                    <FaHeart className="text-red-300 text-6xl mx-2" />
                    <FaHeart className="text-red-300 text-6xl mx-2" />
                    <FaHeart className="text-red-300 text-6xl mx-2" />
                  </div>
  
                  {/* Content */}
                  <div className='relative py-8'>
                    <p className='capitalize'>{walimatulurus}</p>
                    <h2 className='text-2xl font-bold'>{groomName} & {brideName}</h2>
                    <p>{weddingDay}, {formattedDate}</p>
                  </div>
                </div>
                <div className='text-center'>
                  <div className='mb-4'>
                    <div className='flex items-center'>
                      <label className='text-lg p-2'>#</label>
                      <input
                        type="text"
                        value={event}
                        onChange={(e) => {
                          const value = e.target.value.replace(/[^a-zA-Z0-9]/g, ''); // Remove spaces and symbols
                          setEvent(value); // Set the cleaned value
                        }}
                        className="border px-5 py-3 mb-2 w-full"
                        placeholder="Enter hashtag"
                        required
                      />
                    </div>
                    <button
                      onClick={handleHashtag}
                      className="btn-primary px-3 py-2 rounded w-full"
                    >
                      Update #Hashtag
                    </button>
                  </div>
                  <textarea 
                    id="invitationText"
                    value={shareText}
                    readOnly
                    rows="10"
                    className="w-full p-2 border rounded"
                  />
                  <button
                    onClick={handleCopy}
                    className="btn-primary px-3 py-2 rounded w-full"
                  >
                    Copy & Share
                  </button>
                  <div className='flex items-center justify-between space-x-2 mt-2'>
                    <a
                      href={url}
                      target="_blank"
                      rel="noreferrer"
                      className="btn-tertiary text-center px-3 py-2 rounded w-full"
                    >
                      
                      View
                    </a>
                    {isEditDisabled() ? (
                      <button
                        type="button"
                        onClick={handleDisabledEditClick}
                        className="btn-secondary text-center px-3 py-2 rounded w-full opacity-50 cursor-not-allowed"
                        title="Editing is disabled after wedding date"
                      >
                        Edit
                      </button>
                    ) : (
                      <a
                        href={edit}
                        target="_blank"
                        rel="noreferrer"
                        className="btn-secondary text-center px-3 py-2 rounded w-full"
                      >
                        Edit
                      </a>
                    )}
                  </div>
                  <FeaturesModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
                  <div className='my-6 space-y-4'>
                    <div className='flex items-stretch justify-around space-x-2'>
                      <a
                        href={rsvpStatus ? rsvp : "#"}
                        target={rsvpStatus ? "_blank" : "_self"}
                        rel="noreferrer"
                        onClick={rsvpStatus ? null : handleClick} // Disable onClick if rsvpStatus is true
                        className="btn-primary p-3 rounded-lg border border-primary w-1/3 flex flex-col items-center space-y-2"
                      >
                        <FaAddressBook className="text-3xl" />
                        <p className="text-xs">RSVP</p>
                      </a>
                      <a
                        href={musicStatus ? music : "#"}
                        target={musicStatus ? "_blank" : "_self"}
                        rel="noreferrer"
                        onClick={musicStatus ? null : handleClick}
                        className="btn-primary p-3 rounded-lg border border-primary w-1/3 flex flex-col items-center space-y-2"
                      >
                        <FaMusic className="text-3xl" />
                        <p className="text-xs">Music</p>
                      </a>
                      <a
                        href={temaStatus ? tema : "#"}
                        target={temaStatus ? "_blank" : "_self"}
                        rel="noreferrer"
                        onClick={temaStatus ? null : handleClick}
                        className="btn-primary p-3 rounded-lg border border-primary w-1/3 flex flex-col items-center space-y-2"
                      >
                        <FaPalette className="text-3xl" />
                        <p className="text-xs">Designs</p>
                      </a>
                    </div>
                    <div className='flex items-stretch justify-center space-x-2'>
                      <a
                        href={galleries ? gallery : "#"}
                        target={galleries ? "_blank" : "_self"}
                        rel="noreferrer"
                        onClick={galleries ? null : handleClick}
                        className="btn-primary p-3 rounded-lg border border-primary w-1/3 flex flex-col items-center space-y-2"
                      >
                        <FaImage className="text-3xl" />
                        <p className="text-xs">Gallery</p>
                      </a>
                      <a
                        href={pdfStatus ? pdf : "#"}
                        target={pdfStatus ? "_blank" : "_self"}
                        rel="noreferrer"
                        onClick={pdfStatus ? null : handleClick}
                        className="btn-primary p-3 rounded-lg border border-primary w-1/3 flex flex-col items-center space-y-2"
                      >
                        <FaFilePdf className="text-3xl" />
                        <p className="text-xs">Save as PDF</p>
                      </a>
                    </div>
                  </div>
                </div> 
              </div>
            </div>
          </div>
        )
      }
    </div>
    
  );
};

const styles = document.createElement('style');
styles.textContent = `
  @keyframes fadeIn {
    from { opacity: 0; transform: translate(-50%, -20px); }
    to { opacity: 1; transform: translate(-50%, 0); }
  }
  .animate-fade-in {
    animation: fadeIn 0.3s ease-out forwards;
  }
`;
document.head.appendChild(styles);

export default Manage;
